<template>
  <div>
    <div class="ac space-between top">
      <span class="title1">
        {{ title }}
      </span>
      <span v-if="desc" class="desc">
        {{ desc }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  }

}
</script>

<style lang="less" scoped>
.top {
  margin-bottom: .6667rem;
}
.desc{
  font-size: .2933rem;
}
.title1 {
  font-weight: 600;
  font-size: .3733rem;
  font-weight: bold;
  position: relative;

  &::after {
    content: '';
    width: .4533rem;
    height: .0933rem;
    background: #F7931E;
    border-radius: .0533rem;
    position: absolute;
    left: 0;
    bottom: -.2667rem;
  }
}
</style>